import React, { useState, useEffect } from 'react';

import * as S from './styles';

export function SelectInput({
  handlerChange = () => {},
  options,
  width,
  valueSelec,
  value,
  select,
  ...props
}) {
  const [optionsState, setOptionsState] = useState([]);

  useEffect(() => {
    setOptionsState(options || []);
  }, [options]);

  return (
    <S.SelectCustom
      {...props}
      size="middle"
      width={width}
      onChange={selected => handlerChange(selected)}
      value={value}
    >
      {optionsState?.map((option, index) => (
        <S.OptionCuston key={index} value={option?.[select || valueSelec]}>
          {option?.[valueSelec || '']}
        </S.OptionCuston>
      ))}
    </S.SelectCustom>
  );
}
